import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import Employ from './Employ';
export default new Vuex.Store({
    modules: {
        Employ
    },
});


// WEBPACK FOOTER //
// ./src/vuex/store.js